import { FC, PropsWithChildren } from "react";

import classNames from "classnames";

import { createComponentStyleHook } from "../../../../tokens";
import { Bold } from "../../../../typography";

import tokenStyles from "./styles.module.css";
import legacyStyles from "./styles.module.scss";

const useResolvedDropdownGroupHeadingStyles = createComponentStyleHook<PropsWithChildren<{}>>({
  legacyStyles,
  tokenStyles,
  componentTokens: "dropdown_group_heading",
});

/**
 * A group heading component.
 */
export const GroupHeading: FC<PropsWithChildren<{}>> = (props) => {
  const { children } = props;
  const { mode, styles, StyleModeBoundary } = useResolvedDropdownGroupHeadingStyles(props);

  return (
    <StyleModeBoundary mode={mode}>
      <div className={classNames(styles.GroupHeading, "group-heading")}>
        <Bold>{children}</Bold>
      </div>
    </StyleModeBoundary>
  );
};
